module.exports = __webpack_public_path__ + "media/application/images/icons/linkedin-777fad7d366bb2459523dfa3b6458095.svg";